import { defineComponent, onMounted, onUnmounted, ref } from 'vue'
import { Vue3Lottie } from 'vue3-lottie'
import { BannerItem } from '../../../../models/config.model'
import { getBannerList, getUnreachedBannerList } from '../../../../apis/map.api'
import { useComponentStore } from '../../../../nsh5/localStores/component'
import styles from './styles.module.scss'
import animationData from './animation.json'

export default defineComponent({
  name: 'NumberAnimationBg',
  setup: () => {
    const componentStore = useComponentStore()
    const brand = (process.config as { [key: string]: any }).brand
    const isAnimated = ref<boolean>(false)
    const numberAnimationSource = ref<any>()
    const numberAnimationSourcePreList = ref<BannerItem[]>([])
    const isLottie = ref<boolean>(false)

    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig

    // 倒计时关闭全屏弹屏
    const closeNumberAnimation = () => {
      setTimeout(() => {
        isAnimated.value = false
      }, componentsConfig?.number_animation?.properties?.close_time || (window.client === 'mobile' ? 11000 : 21000))
    }

    // 弹屏并缓存
    const numberAnimationCache = (id: string, item: BannerItem) => {
      // 取弹屏本地缓存
      const numberAnimationList = localStorage.getItem('numberAnimationList')
      console.log('numberAnimationList', numberAnimationList)
      // 弹屏本地缓存没有的触发弹屏
      if (!numberAnimationList || !numberAnimationList.includes(id, 0)) {
        // 弹屏物料匹配赋值
        item &&
          window
            .fetch(item?.picture)
            .then((response) => response.json())
            .then((json) => {
              numberAnimationSource.value = json
            })
            .catch((error) => {
              console.error('Failed to load animation data:', error)
              numberAnimationSource.value = animationData
            })
        // 是否Lottie动画
        if (item?.picture?.split('.').pop()?.includes('json', 0)) {
          isLottie.value = true
        }
        // 显示全屏弹屏
        isAnimated.value = true
        // 触发倒计时关闭
        closeNumberAnimation()
        // 记录弹屏本地缓存
        !numberAnimationList
          ? localStorage.setItem('numberAnimationList', id)
          : localStorage.setItem('numberAnimationList', `${numberAnimationList},${id}`)
      }
    }

    // 检查是否已经初始化过
    const isInitialized = () => {
      // 检查内存中是否已有数据
      if (numberAnimationSourcePreList.value.length > 0) {
        return true
      }
      // 检查 componentStore 中是否有初始化标记
      return componentStore.numberAnimationInitialized === true
    }

    // 标记为已初始化
    const markAsInitialized = () => {
      componentStore.$patch({ numberAnimationInitialized: true })
    }

    // 全屏弹屏，已开始正在进行
    const getNumberAnimation = () => {
      getBannerList('nsh5_number_animation').then((res: any) => {
        if (res.isValid()) {
          // 接口请求成功，标记为已初始化（无论是否有数据）
          markAsInitialized()
          if (res.data.length > 0) {
            const item = res.data[0]
            // 弹屏并缓存
            item && numberAnimationCache(item.id, item)
          }
        }
      })
    }

    // 全屏弹屏预请求，未开始
    const getNumberAnimationPre = () => {
      getUnreachedBannerList('nsh5_number_animation').then((res: any) => {
        if (res.isValid()) {
          // 接口请求成功，标记为已初始化（无论是否有数据）
          markAsInitialized()
          if (res.data.length > 0) {
            numberAnimationSourcePreList.value = res.data
            res.data.map((item: BannerItem, index: number) => {
              const img = new Image()
              img.addEventListener('load', () => {
                // 图片加载完成
              })
              img.src = res.data[index]?.picture
              img.className = styles.hide
              document.body.appendChild(img)
            })
          }
        }
      })
    }

    // 弹屏物料匹配&&弹屏显示
    const handleNumberAnimationShow = (id: string) => {
      console.log('handleNumberAnimationShow', id)
      // id匹配
      const matchItem = numberAnimationSourcePreList.value.find((c: BannerItem) => c.id === id)
      // 弹屏并缓存
      matchItem && numberAnimationCache(id, matchItem)
    }

    onMounted(() => {
      if (componentsConfig?.number_animation?.show) {
        // 如果已经初始化过，不再重新请求接口
        if (!isInitialized()) {
          getNumberAnimation()
          getNumberAnimationPre()
          setTimeout(() => {
            // 延迟请求时也检查是否已初始化
            if (!isInitialized()) {
              getNumberAnimationPre()
            }
          }, componentsConfig?.number_animation?.properties?.retry_time || 15 * 60 * 1000)
        }
        componentStore.bus.on('numberAnimationShow', handleNumberAnimationShow)
      }
    })

    onUnmounted(() => {
      componentStore.bus.off('numberAnimationShow', handleNumberAnimationShow)
    })

    return () => {
      return (
        <>
          {isAnimated.value && numberAnimationSource.value && (brand === 'nio' || brand === 'alps') ? (
            <div class={[styles.numberAnimation, window.client === 'mobile' ? styles.numberAnimationMobile : '']}>
              {isLottie.value ? (
                <Vue3Lottie loop={ window.client === 'mobile' ? 3 : 6 } class={styles.lottie} animationData={numberAnimationSource.value} />
              ) : null}
            </div>
          ) : null}
        </>
      )
    }
  },
})

